import cx from 'classnames';
import Path from "./Path.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Hexagons(_ref) {
  let {
    id,
    height,
    fill,
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeLinecap,
    shapeRendering,
    background,
    className,
    size = 3
  } = _ref;
  const sqrtSize = Math.sqrt(size);
  return /*#__PURE__*/_jsx(Path, {
    className: cx('visx-pattern-hexagon', className),
    path: `M ${height},0 l ${height},0 l ${height / 2},${height * sqrtSize / 2} l ${-height / 2},${height * sqrtSize / 2} l ${-height},0 l ${-height / 2},${-height * sqrtSize / 2} Z M 0,${height * sqrtSize / 2} l ${height / 2},0 M ${3 * height},${height * sqrtSize / 2} l ${-height / 2},0`,
    id: id,
    width: size,
    height: sqrtSize,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    strokeLinecap: strokeLinecap,
    shapeRendering: shapeRendering,
    background: background
  });
}